export const needToAddBookmark = ({ bookmarks, jid }) => {
  const hasMatch = bookmarks?.find((i) => i.jid === jid)
  return !hasMatch
}

export const dummy = () => {}
